// Wrapper for easily mocking globals in testing
module.exports = {
  window: window,
  document: document,
};


//////////////////
// WEBPACK FOOTER
// ./src/globals.js
// module id = 2
// module chunks = 0